import { useEffect } from 'react'
import { buildProductAnalyticsData } from '../utils/tracking/tracking'
import { TemplateConfigurationSection } from '../types/TemplateConfiguration'
import { ShortMsxMpv } from '../types/ShortMsxMpv'
import { AutomatedExperience } from './AutoGenerate/types/AutomatedExperience'
import { FeatureFlags } from '../types/Global'
import { ProductRecommendationsData } from '../types/Recommendations'

type ProductListTrackingValues = {
  sections: TemplateConfigurationSection[]
  mpvs: ShortMsxMpv[]
  automatedExperience?: AutomatedExperience | undefined
  featureFlags?: FeatureFlags | undefined
  productRecommendations?: ProductRecommendationsData | undefined
}
export const useProductListTracking = (productListTrackingValues: ProductListTrackingValues) => {
  const { sections, mpvs, automatedExperience, featureFlags, productRecommendations } =
    productListTrackingValues
  const sendTrackTracking = () => {
    const tracking = (window as any).tracking as any
    if (tracking && tracking.track) {
      const splitLength = 25
      const productList = buildProductAnalyticsData({
        sections,
        mpvs,
        automatedExperience,
        featureFlags,
        productRecommendations
      })
      for (let i = 0; i < productList.length; i += splitLength) {
        tracking.track('Product List Viewed', {
          label: 'Category page view',
          list_id: 'Category Page',
          products: productList.slice(i, i + splitLength)
        })
      }
    } else {
      setTimeout(() => sendTrackTracking(), 1000)
    }
  }

  useEffect(() => {
    sendTrackTracking()
  }, [])
}
